module.exports = __webpack_public_path__ + "img/img38.7c16398a.png";